export const isLocalhost = () => {
    const host = window.location.hostname;
    const localEnv = import.meta.env.VITE_FRONTEND_LOCAL;
    if (host.includes(localEnv) || host === "127.0.0.1") {
        return true;
    } else {
        return false;
    }
};

export const isInternal = () => {
    if (window.location.href.includes("192.168.")) {
        return true;
    } else {
        return false;
    }
};

export const isDemo = () => {
    const host = window.location.hostname;
    const demoEnv = import.meta.env.VITE_FRONTEND_DEMO;
    if (host.includes(demoEnv)) {
        return true;
    } else {
        return false;
    }
};

export const isTest = () => {
    const host = window.location.hostname;
    const testEnv = import.meta.env.VITE_FRONTEND_TEST;
    if (host.includes(testEnv)) {
        return true;
    } else {
        return false;
    }
};

export const isQA = () => {
    const host = window.location.hostname;
    const qaEnv = import.meta.env.VITE_FRONTEND_QA;
    if (host.includes(qaEnv)) {
        return true;
    } else {
        return false;
    }
};

export const isProd = () => {
    const host = window.location.hostname;
    const prodEnv = import.meta.env.VITE_FRONTEND_PROD;
    if (host.includes(prodEnv)) {
        return true;
    } else {
        return false;
    }
};

export const getServerType = () => {
    var type = "";

    if (isLocalhost()) {
        type = "LOCAL";
    } else {
        if (isDemo()) {
            type = "DEMO";
        } else {
            if (isProd()) {
                type = "PROD";
            } else {
                if (isTest()) {
                    type = "TEST";
                }
            }
        }
    }

    return type;
};

export const backendApi = () => {
    var backend = null;
    var backendApi = null;

    if (isDemo()) {
        backend = import.meta.env.VITE_BACKEND_DEMO;
    } else {
        if (isProd()) {
            backend = import.meta.env.VITE_BACKEND_PROD;
        } else {
            if (isTest()) {
                backend = import.meta.env.VITE_BACKEND_TEST;
            } else {
                if (isQA()) {
                    backend = import.meta.env.VITE_BACKEND_QA;
                } else {
                    if (isInternal()) {
                        backend = import.meta.env.VITE_BACKEND_INTERN;
                    } else {
                        // isLocalhost()
                        // by default localhost
                        backend = import.meta.env.VITE_BACKEND_LOCAL;
                    }
                }
            }
        }
    }

    if (backend) {
        backendApi = backend + import.meta.env.VITE_API_PATH;
    }

    return backendApi;
};

// clean the path removing ending /
export const cleanPath = (path) => {
    var clean = path;
    if (path !== "/") {
        clean = path.replace(/\/$/, "");
    }
    return clean;
};
